export default __webpack_public_path__ + "static/media/vy.c0ebef9f.bin";